(() => {
  const menus = [...document.querySelectorAll('[data-shop-menu]')];
  if (!menus.length) return;

  const close = (menu) => {
    const trigger = menu.querySelector('[data-shop-trigger]');
    const panel = menu.querySelector('[data-shop-panel]');
    if (!trigger || !panel) return;
    trigger.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
  };

  menus.forEach((menu) => {
    const trigger = menu.querySelector('[data-shop-trigger]');
    const panel = menu.querySelector('[data-shop-panel]');
    if (!trigger || !panel) return;
    trigger.addEventListener('click', (event) => {
      if (trigger.getAttribute('aria-expanded') === 'true') return;
      event.preventDefault();
      menus.forEach(close);
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    });
    trigger.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown' && trigger.getAttribute('aria-expanded') !== 'true') {
        event.preventDefault();
        trigger.click();
        panel.querySelector('a')?.focus();
      }
    });
    menu.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      close(menu);
      trigger.focus();
    });
  });

  document.addEventListener('click', (event) => {
    menus.forEach((menu) => { if (!menu.contains(event.target)) close(menu); });
  });
})();
